import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { FlagDetail, FlagSimulationResult, TenantEvaluation } from './flagMatrixTypes';

export const useFlagMatrix = (tenantNames: string[]) => {
  const { data, isLoading, isError } = useQuery<TenantEvaluation[]>({
    queryKey: ['admin', 'feature-flags', 'matrix', tenantNames],
    queryFn: () =>
      api
        .post<TenantEvaluation[]>('admin/feature-flags/matrix', { tenantNames })
        .then(response => response.data),
    enabled: tenantNames.length > 0,
  });

  return { matrix: data, isLoading, isError };
};

export const useFlagDetail = (flagKey: string | null) => {
  const { data, isLoading, error } = useQuery<FlagDetail>({
    queryKey: ['admin', 'feature-flags', flagKey],
    enabled: flagKey !== null,
  });

  return { detail: data, isLoading, error };
};

type SimulationVariables = { tenantName: string; email?: string; userId?: string };

export const useFlagSimulation = () =>
  useMutation<FlagSimulationResult[], Error, SimulationVariables>({
    mutationFn: ({ tenantName, email, userId }) =>
      api
        .get<FlagSimulationResult[]>(`admin/feature-flags/evaluate/${tenantName}`, {
          email,
          userId,
        })
        .then(response => response.data),
  });
